export default __webpack_public_path__ + "static/media/menu_img.f5ce356b.webp";